/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_87cc6bdc","_87cc6bdc",""]'><div :class='["","_87cc6bdc",""]'><cube-button @_click="showPicker" :class='["","_87cc6bdc",""]'>Date-Picker</cube-button><cube-date-picker-modal ref="__mpx_ref_picker__" title="日期选择器" content="请选择具体的时间" :columnCount="(4)" :min="(min)" :max="(max)" :value="(value)" @toggle='(e)=>__invoke(e, [["onToggle"]])' @close='(e)=>__invoke(e, [["onClose"]])' @change='(e)=>__invoke(e, [["onChange"]])' @columnChange='(e)=>__invoke(e, [["onColumnChange"]])' @confirm='(e)=>__invoke(e, [["onConfirm"]])' @valueChange='(e)=>__invoke(e, [["onValueChange"]])' :class='["","_87cc6bdc",""]'/><div :class='["demo-data","_87cc6bdc",""]' v-if="(confirmParams.length || valueChangeParams.length)"><div :class='["key","_87cc6bdc",""]'>其他事件可打开控制台查看输出</div><template v-if="(confirmParams.length)"><div :class='["key","_87cc6bdc",""]'>confirmParams 事件参数：</div><div :class='["value","_87cc6bdc",""]'><div v-for="(item, index) in (confirmParams)" :key="item.index" :class='["value-item","_87cc6bdc",""]'><div :class='["item-key","_87cc6bdc",""]'>{{item[0]}}</div><div :class='["item-value","_87cc6bdc",""]'>{{item[1]}}</div></div></div></template><template v-if="(valueChangeParams.length)"><div :class='["key","_87cc6bdc",""]'>valueChange 事件触发次数：{{ valueChangeCount }}</div><div :class='["key","_87cc6bdc",""]'>valueChangeParams 事件参数：</div><div :class='["value","_87cc6bdc",""]'><div v-for="(item, index) in (valueChangeParams)" :key="item.index" :class='["value-item","_87cc6bdc",""]'><div :class='["item-key","_87cc6bdc",""]'>{{item[0]}}</div><div :class='["item-value","_87cc6bdc",""]'>{{item[1]}}</div></div></div></template></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_87cc6bdc"}'>
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_87cc6bdc"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_87cc6bdc"}
  /** script content **/
  require("./basic-picker.mpx.js?isComponent&outputPath=components%2Fbasic-picker87cc6bdc%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./basic-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbasic-picker87cc6bdc%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_87cc6bdc"],
    ctorType: "component",
    outputPath: "components/basic-picker87cc6bdc/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker-modal/index.mpx?isComponent&outputPath=components%2Findex5001a0cc%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>